import { createBaseResponseErrors } from '@/utils/errors/baseResponseErrors'
import { createBaseCRUDApi } from '@/api/base'
import { PTO_URL } from './const'

export const PTO_BUILDING_URL = `${PTO_URL}/building`

const errors = createBaseResponseErrors('стройку', 'строек')

export const PTOBuildingApi = createBaseCRUDApi(PTO_BUILDING_URL, errors)
